import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";

const PRIVACY_TEXT = `
AVISO DE PRIVACIDAD

Aplicación Móvil Caliente®
Última actualización: 17 de mayo de 2026
Al descargar, instalar o utilizar la aplicación móvil de Caliente® (en adelante, la “App”), usted reconoce haber leído y aceptado los términos del presente Aviso de Privacidad, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de Particulares (LFPDPPP) publicada el 20 de marzo de 2025.

1.RESPONSABLE DEL TRATAMIENTO
Hipódromo de Agua Caliente, S.A. de C.V. (en adelante CALIENTE®) y sus empresas afiliadas y subsidiarias, con domicilio en Blvd. Agua Caliente 12027, Col. Hipódromo, C.P. 22420, Tijuana, B.C., México.

El responsable del tratamiento de sus datos personales es el Departamento de Seguridad y Riesgo Informático:
Domicilio: Blvd. Agua Caliente 12027, Col. Hipódromo, C.P. 22420, Tijuana, B.C., México
Teléfono: (664) 647 4770
Correo electrónico: protecciondedatos@caliente.com.mx
CALIENTE® es una unidad económica conformada por empresas permisionarias de juegos y sorteos debidamente reguladas por la Secretaría de Gobernación conforme a la Ley Federal de Juegos y Sorteos.

2. DATOS PERSONALES QUE RECABAMOS A TRAVÉS DE LA APP

Al utilizar la App, recabamos sus datos personales a través de los siguientes medios:
Los que usted nos proporciona directamente al registrarse o usar la App
Los generados automáticamente por su dispositivo móvil al interactuar con la App
Los obtenidos mediante fuentes lícitas permitidas por la ley

A. Datos de identificación:
Nombre completo
Fecha de nacimiento
Nacionalidad
Domicilio
Teléfono celular
Correo electrónico
CURP y RFC
Identificación oficial vigente
Firma autógrafa o electrónica
Fotografía o selfie de verificación

B. Datos financieros:
Información de tarjetas bancarias
Información de cuentas bancarias
Historial de transacciones
Comprobantes de domicilio recientes

C. Datos técnicos del dispositivo móvil:
Identificador único del dispositivo (Device ID)
Sistema operativo y versión (iOS / Android)
Dirección IP
Modelo y fabricante del dispositivo
Datos de geolocalización (únicamente cuando sea necesario para verificar su ubicación conforme a la normativa aplicable)
Versión de la App instalada
Registro de uso y actividad dentro de la App
Identificadores publicitarios móviles (IDFA / GAID), en su caso

D. Datos sensibles:
CALIENTE® no recaba datos personales sensibles de manera regular. En caso de requerirse, se solicitará su consentimiento expreso y por escrito conforme a la LFPDPPP.

3. FINALIDADES DEL TRATAMIENTO

Finalidades primarias (necesarias para el servicio):
Verificar y confirmar su identidad y mayoría de edad (18 años o más)
Crear, mantener y administrar su cuenta de usuario en la App
Procesar sus transacciones (depósitos, retiros y apuestas)
Proveer los servicios y productos solicitados a través de la App
Administrar su participación en el programa de lealtad y promociones
Cumplir con las obligaciones de identificación del cliente conforme a la LFPIORPI (umbral de 325 UMA / 24 horas) y demás normativa aplicable en materia de prevención de lavado de dinero
Procesar el pago de premios superiores a 325 UMA conforme a la regulación vigente
Atender solicitudes, quejas, dudas y comentarios
Facturación y registro contable
Prevenir el fraude, el lavado de dinero y el uso indebido de la App
Dar cumplimiento a obligaciones legales y regulatorias aplicables

Finalidades secundarias (no necesarias para el servicio, pero sujetas a su consentimiento):
Enviarle información sobre cambios, nuevos productos o servicios
Realizarle encuestas de satisfacción y calidad
Elaborar estudios sobre hábitos de consumo y preferencias dentro de la App
Enviarle notificaciones push con promociones y publicidad personalizada
Crear perfiles de usuario para fines mercadotécnicos o publicitarios
Análisis estadístico y de mercado

Si no desea que sus datos sean usados para finalidades secundarias, puede manifestar su negativa en: protecciondedatos@caliente.com.mx o a través de la sección de Privacidad en la configuración de la App.

4. TRANSFERENCIA DE DATOS PERSONALES

CALIENTE® podrá transferir sus datos personales sin requerir su consentimiento en los supuestos establecidos en el artículo 37 de la LFPDPPP, incluyendo:
Autoridades federales y locales competentes
Sociedades controladoras, subsidiarias o afiliadas del mismo grupo empresarial que operen bajo los mismos procesos y políticas internas
Instituciones bancarias y financieras para el procesamiento de transacciones
Proveedores de servicios tecnológicos necesarios para la operación de la App (incluyendo servicios de nube, análisis y seguridad)
Empresas especializadas en prevención de fraude y lavado de dinero
Proveedores de envíos de comunicaciones (BMM Bismarketing México S.A. de C.V. y Tecnología y Soluciones Aplicadas S.A. de C.V.)

Fuera de los supuestos del artículo 37, CALIENTE® obtendrá su consentimiento previo y expreso para cualquier otra transferencia. Todo proveedor que reciba sus datos estará sujeto a convenios de confidencialidad y al cumplimiento del presente Aviso.

5. MEDIDAS DE SEGURIDAD

CALIENTE® aplica medidas de seguridad administrativas, técnicas y físicas para proteger sus datos personales contra acceso no autorizado, daño, pérdida, alteración o destrucción. Esto incluye, entre otras medidas, el cifrado de datos en tránsito y en reposo, autenticación de múltiples factores y controles de acceso dentro de la App.

6. DERECHOS ARCO

Usted tiene derecho a:
Acceso: conocer qué datos tenemos de usted, para qué los usamos y en qué condiciones
Rectificación: corregir su información cuando esté desactualizada, inexacta o incompleta
Cancelación: solicitar la eliminación de sus datos de nuestros registros cuando no sean necesarios para las finalidades que motivaron su tratamiento
Oposición: oponerse al uso de sus datos para finalidades específicas

Para ejercer sus derechos ARCO, envíe su solicitud a:
Correo electrónico: protecciondedatos@caliente.com.mx
Sección “Privacidad” dentro de la configuración de la App
Presencialmente en cualquier establecimiento de CALIENTE® o en la oficina del Departamento de Seguridad y Riesgo Informático, Blvd. Agua Caliente 12027, Col. Hipódromo, C.P. 22420, Tijuana, B.C. Teléfono: (664) 647 4770

Su solicitud deberá incluir:
Nombre completo y medio de contacto para recibir respuesta
Documentos que acrediten su identidad o representación legal
Descripción clara de los datos y del derecho que desea ejercer
Cualquier elemento que facilite la localización de sus datos

CALIENTE® le dará respuesta en un plazo máximo de 20 días hábiles a partir de la recepción de su solicitud, prorrogable por un período igual cuando las circunstancias lo justifiquen. La medida adoptada se hará efectiva dentro de los 15 días hábiles siguientes a la comunicación de la respuesta.

7. REVOCACIÓN DEL CONSENTIMIENTO

Usted puede revocar el consentimiento otorgado para el tratamiento de sus datos personales enviando su solicitud por escrito a protecciondedatos@caliente.com.mx o a través de la sección de Privacidad en la configuración de la App.

Tenga en cuenta que la revocación del consentimiento no aplica cuando el tratamiento sea necesario para cumplir obligaciones legales, y que para determinadas finalidades, la revocación podría implicar la conclusión de su relación con CALIENTE® y la imposibilidad de acceder a la App.

8. LIMITACIÓN DEL USO O DIVULGACIÓN

Para limitar el uso de sus datos con fines publicitarios, puede:
Inscribirse en el Registro Público para Evitar Publicidad (REPEP) de PROFECO
Solicitar su inscripción en el “Listado de Exclusión” enviando un correo a protecciondedatos@caliente.com.mx
Desactivar las notificaciones push en la configuración de su dispositivo móvil o dentro de la App

9. TECNOLOGÍAS DE RASTREO EN LA APP

La App utiliza tecnologías propias y de terceros para monitorear su comportamiento como usuario, optimizar el rendimiento de la App y brindarle una mejor experiencia, incluyendo:
Identificadores de sesión
SDKs de análisis de comportamiento (p. ej., Firebase Analytics, Mixpanel)
Identificadores publicitarios móviles (IDFA en iOS / GAID en Android)
Registros de errores y rendimiento

Puede limitar el uso de identificadores publicitarios desde la configuración de privacidad de su dispositivo móvil (iOS: Configuración > Privacidad > Seguimiento; Android: Configuración > Privacidad > Anuncios).
Nota: La App no utiliza cookies de navegador, pues su operación es nativa para dispositivos móviles.

10. MODIFICACIONES AL AVISO DE PRIVACIDAD

CALIENTE® se reserva el derecho de actualizar este Aviso en cualquier momento para atender cambios legislativos, políticas internas o nuevos servicios. Las modificaciones serán notificadas a través de:
Notificación push en la App
Aviso dentro de la App al iniciar sesión
Correo electrónico al último registrado en su cuenta
Avisos visibles en nuestros establecimientos y en www.calientecasino.com.mx

11. AUTORIDAD COMPETENTE

Si considera que sus derechos en materia de protección de datos personales han sido vulnerados, puede presentar su queja ante la Secretaría Anticorrupción y Buen Gobierno. Para más información, consulte los canales oficiales de información gubernamental.

12. CONSENTIMIENTO

Al utilizar la App, usted manifiesta que ha leído, entendido y aceptado libremente los términos del presente Aviso de Privacidad, otorgando su consentimiento libre, específico, inequívoco e informado para el tratamiento de sus datos personales en los términos aquí descritos, incluyendo las actualizaciones que se realicen en el futuro y que le sean debidamente notificadas.

Más información
www.calientecasino.com.mx  •  protecciondedatos@caliente.com.mx  •  (664) 647 4770
Fecha de última actualización: 17 de mayo de 2026

`;

function cleanPrivacyText(text: string) {
  return text
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .filter((line) => !/^\d+$/.test(line));
}

export default function PrivacyPolicy() {
  const lines = cleanPrivacyText(PRIVACY_TEXT);

  return (
    <>
       <Navbar navLight={false} playBtn={true} bgLight={false} navCenter={true} />

      <main className="min-h-screen bg-white dark:bg-[#000000] text-slate-600 dark:text-[#b5b5b5]">
        <section className="relative py-28 md:py-36">
          <div className="container">
            <div className="max-w-5xl mx-auto">
              <Link
                to="/"
                className="inline-flex mb-8 text-red-500 hover:text-red-600 duration-300"
              >
                ← Volver al inicio
              </Link>

              <div className="bg-white dark:bg-[#1d1d1d] rounded-2xl shadow-lg p-6 md:p-10 border border-gray-200 dark:border-white/10">
                <h1 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-8">
                  Aviso de Privacidad
                </h1>

                <div className="space-y-4 leading-7">
                  {lines.map((line, index) => {
                    const isTitle =
                      line === "AVISO DE PRIVACIDAD" ||
                      /^\d+\.\s?[A-ZÁÉÍÓÚÑ]/.test(line);

                    if (isTitle) {
                      return (
                        <h2
                          key={index}
                          className="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white pt-6"
                        >
                          {line}
                        </h2>
                      );
                    }

                    return (
                      <p key={index} className="text-slate-600 dark:text-[#b5b5b5]">
                        {line}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <Switcher />
    </>
  );
}